import { Filter, FilterType } from '@dfl/mui-admin-layout';
import { createdATFilter } from 'modules/common/constants/filters/common.filters';
import { getProviderLogisticFilter, getVisibleFilter } from 'modules/common/constants/filters';
import { addressFilters } from 'lib/dfl-address-filter/filters';
import { WarehouseService } from 'modules/inventory/warehouse/services';
import { transformWhitObjectId } from 'modules/common/constants/object-id';

export const warehouseFilter: Filter = {
  filter: 'common:warehouse',
  translate: true,
  type: FilterType.DYNAMIC_LIST,
  key: 'warehouse',
  labelKey: 'name',
  field: 'items.warehouse._id',
  fetchFunc: WarehouseService.search,
  fetchOption: { size: 200 },
  queryKey: 'WAREHOUSES_LIST',
  transform: (value) => transformWhitObjectId(value, 'items.warehouse._id'),
};

const visibleFilter = getVisibleFilter('visible');
const logisticFilter = getProviderLogisticFilter('logistic._id');

const handlingCostFilter: Filter = {
  filter: 'logistics:fields:handlingCost',
  translate: true,
  type: FilterType.NUMBER,
  key: 'hc',
  field: 'handlingCost.value',
};

const distributionCenterFilters = addressFilters({
  countryFilter: 'warehouse:address.country',
  countryKey: 'country',
  countryField: 'address.country',
  stateFilter: 'warehouse:address.state',
  stateKey: 'state',
  stateField: 'address.state',
  cityFilter: 'warehouse:address.city',
  cityKey: 'city',
  cityField: 'address.city',
  justUseFor: 'CU',
});

// distributionCentersFilters list
export const distributionCentersFilters: Filter[] = [
  logisticFilter,
  ...distributionCenterFilters,
  handlingCostFilter,
  visibleFilter,
  createdATFilter,
];

export const defaultDistributionCentersFilters: Filter[] = [logisticFilter, handlingCostFilter, visibleFilter];

export const distributionCentersReportFilters: Filter[] = [createdATFilter, warehouseFilter];
